import { SVGAttributes, ReactElement } from 'react'

type Props = SVGAttributes<SVGElement>

function SvgChevronIcon(props: Props): ReactElement {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 14 14"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.476.72A.827.827 0 014.644.657l6.364 5.727a.827.827 0 010 1.23l-6.364 5.727a.827.827 0 01-1.107-1.23L9.217 7l-5.68-5.112A.827.827 0 013.476.719z"
            />
        </svg>
    )
}

export default SvgChevronIcon
